import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCompaniesOfEmployee } from "../actions/employeeActions";
import PaperContainer from "./PaperContainer";
import CompanyEmployeeList from "./CompanyEmployeeList";

class EmployeeListPerCompany extends Component {
  state = {
    companies: [],
  };

  componentDidMount() {
    this.props
      .getCompaniesOfEmployee(this.props.employeeEmail, true)
      .then((response) => {
        this.setState({ companies: response });
      });
  }

  render() {
    return (
      <Fragment>
        {this.state.companies.map((company, i) => {
          return (
            <PaperContainer
              key={company.email}
              title={"Medewerkers van " + company.name}
              isAccordion={true}
              isOpen={i == 0}
            >
              <CompanyEmployeeList company={company.email} />
            </PaperContainer>
          );
        })}
      </Fragment>
    );
  }
}

EmployeeListPerCompany.propTypes = {
  employeeEmail: PropTypes.string.isRequired,
  getCompaniesOfEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isFetching: state.employee.getCompaniesOfEmployee.isFetching,
});

export default connect(mapStateToProps, { getCompaniesOfEmployee })(
  EmployeeListPerCompany,
);



// WEBPACK FOOTER //
// ./src/components/EmployeeListPerCompany.js